
export enum TripNodeTypeCd {
	DESTINATION = 'Destination',
	ORIGIN = 'Origin',
	STOP = 'Stop'}

